// extracted by mini-css-extract-plugin
export default {"root_scroller":"zP","flex_container":"AP","container":"BP","scroller":"CP","indicator":"EP","scrollButtons":"FP","selected":"GP","root_tab":"HP","root_tab_scrollable":"IP","root_scroller_mob":"JP","scroller_mob":"KP","indicator_mob":"LP","selected_mob":"MP","root_tab_mob":"NP","root_tab_mob_scrollable":"OP"};
    if(module.hot) {
      // 1738836197359
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  